import { Draft } from '@reduxjs/toolkit';

import { IInterventionData } from '../../initialState';

function editFailure(draft: Draft<IInterventionData>) {
  draft.edit.config.isLoading = false;
}

export default editFailure;
